<template>
  <div>
    <DepartmentView01 />
    <ForDept class="mt20" ref="forDept" :queryRang="2" />
    <ForHandle class="mt20" ref="forHandle" :queryRang="2" />
    <ForLink class="mt20 mb20" ref="forLink" :queryRang="2" />
  </div>
</template>

<script>
import DepartmentView01 from "@/components/statistical/department/DepartmentView01";
import ForDept from "@/components/statistical/ForDept";
import ForHandle from "@/components/statistical/ForHandle";
import ForLink from "@/components/statistical/ForLink";

export default {
  name: "Department",
  components: {
    DepartmentView01,
    ForDept,
    ForHandle,
    ForLink
  },
  props: [],
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {},
  watch: {},
  filters: {}
};
</script>

<style scoped>
</style>
